import _ from 'lodash';
import Papa from 'papaparse';
import Encoding from 'encoding-japanese';
import { BatchType } from '@/constants';

export const keyMap = new Map([
  ['GET_STORE_GROUP', '店舗グループ'],
  ['GET_DASHBOARD', 'ダッシュボード'],
  ['ADD_BOOKMARK', 'しおりの作成と通知'],
  ['ADD_CLIP', 'クリップの作成と通知'],
  ['SET_TAG', 'タグ設定'],
  ['SET_CAMERA', 'カメラ設定'],
  ['SET_LOGOUT_TIME', 'ログアウトの時間設定'],
  ['SET_RECORDING', '録画停止'],
  // default true이므로 제외
  // ['GET_RECORDING_SUB_BRANCH', 'ライブ映像視聴、録画再生'],
  ['DOWNLOAD_RECORDING_SUB_BRANCH', '録画データダウンロード'],
  ['SET_PTZ_SUB_BRANCH', 'PTZ操作']
]);

export const keyMapPrivate = new Map([
  ['GET_OWN_STORE', '自店舗'],
  // ['GET_DASHBOARD', 'ダッシュボード'],
  ['ADD_BOOKMARK', 'しおりの作成と通知'],
  ['ADD_CLIP', 'クリップの作成と通知'],
  ['SET_TAG', 'タグ設定'],
  ['SET_CAMERA', 'カメラ設定'],
  ['SET_LOGOUT_TIME', 'ログアウトの時間設定'],
  ['SET_RECORDING', '録画停止'],
  // default true이므로 제외
  // ['GET_RECORDING', 'ライブ映像視聴、録画再生'],
  ['DOWNLOAD_RECORDING', '録画データダウンロード'],
  ['SET_PTZ', 'PTZ操作']
])

export default {
  role: 'main',
  mapAuthGroup(authGroup) {
    const permissionTable = this.role === 'private' || this.role === 'branch' ? keyMapPrivate : keyMap;
    const result = {};
    permissionTable.forEach((translatedKey, key) => {
      result[translatedKey] = authGroup[key];
    });
    return result;
  },
  addTodayStr(prefix) {
    // 오늘 날짜의 포맷은 YYYYMMDD
    // const today = new Date().toISOString().slice(0, 10).replace(/-/g, '');
    const today = new Date().toLocaleString('en-CA', { timeZone: 'Asia/Tokyo', year: 'numeric', month: '2-digit', day: '2-digit' }).replace(/-/g, '');
    return `${prefix}_${today}.csv`;
  },
  exportUserAuthorityCSV(data) {
    console.log(this.role);
    const csvData = data.map(entry => {
      const authGroup = entry.authGroup;
      console.log('entry', entry);
      // Merge the main entry with the filtered authGroup
      return {
          '名前': entry.name,
          'ユーザーID': entry.userName,
          'メールアドレス': entry.mailAddress,
          // '権限': entry.accountRole,
          '権限グループ名': entry.userGroupAuthGroupName,
          '権限グループID': entry.userGroupAuthGroupId,
          'UMID': entry.umid,
          ...this.mapAuthGroup(entry.authGroup),
      };
    });
  
    // Convert the array of objects to a CSV string
    const csv = Papa.unparse(csvData, {
      header: true,
      skipEmptyLines: true
    });
  
    return csv;
  },
  exportUserGroupCSV(data) {
    const csvData = data.map(entry => {
      const authGroup = entry.authGroup;
      console.log('entry', entry);
      // Merge the main entry with the filtered authGroup
      return {
          '権限グループ名': entry.name,
          '権限グループID': entry.id,
          ...this.mapAuthGroup(entry.authGroup),
          'COMMAND': '',
      };
    });
    const csv = Papa.unparse(csvData, {
      header: true,
      skipEmptyLines: true
    });
  
    return csv;
  },
  exportStoreGroupCSV(data) {
    const csvData = [];
    data.forEach(entry => {
      console.log('entry', entry);
      entry.sharedUserStoreGroups.forEach(userGroup => {
          csvData.push({
              'ユーザID': userGroup.userName,
              'ユーザ名': userGroup.name,
              '店舗グループID': userGroup.storeGroupId,
              '店舗グループ名': entry.groupName,
              'メールアドレス': userGroup.mailAddress,
              'ID': userGroup.id,
              'UMID': userGroup.umid,
              'COMMAND': '',
          });
      });
    });
    const csv = Papa.unparse(csvData, {
      header: true,
      skipEmptyLines: true
    });
  
    return csv;
  },
  downloadCSV(csv, filename) {
    // CSV 문자열을 Shift-JIS 바이트 배열로 변환
    const sjisArray = Encoding.convert(Encoding.stringToCode(csv), {
      to: 'SJIS', from: 'UNICODE'
    });

    // 바이트 배열로 Blob 생성
    const blob = new Blob([new Uint8Array(sjisArray)], { type: 'text/csv;charset=shift-jis;' });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);
    
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  },
  exportCSV(data, type, role) {
    this.role = role;
    let csvFunction = null;
    let filenamePrefix = '';
    switch (type) {
      case BatchType.USER_AUTHORITY:
        csvFunction = this.exportUserAuthorityCSV;
        filenamePrefix = 'csv_camera_users_permission';
        break;
      case BatchType.USER_GROUP:
        csvFunction = this.exportUserGroupCSV;
        filenamePrefix = 'csv_camera_permission_groups';
        break;
      case BatchType.STORE_GROUP:
        csvFunction = this.exportStoreGroupCSV;
        filenamePrefix = 'csv_camera_users_storegroups';
        break;
      default:
        // Handle unknown type or do nothing
        return;
    }
    const csv = csvFunction.call(this, data, role);
    const filename = this.addTodayStr(filenamePrefix);
    this.downloadCSV(csv, filename);
  }
}

/*
{
  // "ADD_SHARE_USER": '', // 공유 사용자 추가
  // "ADD_STORE_GROUP": '', // 점포그룹생성 및 사용자 할당
  // "SET_PERMISSIONS_GROUP": '', // 권한 그룹에 대한 기능설정
  // "SET_BRANCH_USER": '', // 지점 사용자에 대한 기능 설정
  // "GET_TOTAL_STORES": '', // 전점포통계
  "GET_STORE_GROUP": '店舗グループ', // 점포그룹 통계
  // "GET_OWN_STORE": '', // 자기(단일)점포 통계
  "GET_DASHBOARD": 'ダッシュボード', // 대시보드
  // "SEARCH_STORE": '', // 점포검색
  // "SEARCH_LOG": '', // 로그
  "ADD_BOOKMARK": 'しおりの作成と通知', // 북마크생성과 알람
  "ADD_CLIP": 'クリップの作成と通知', // 클립생성과 알람
  "SET_TAG": 'タグ設定', // 태그 설정
  "SET_CAMERA": 'カメラ設定', // 카메라 설정
  // "SET_DISCONNECTION_ALARM": '', // 연결끊김 알림시간 설정
  "SET_LOGOUT_TIME": 'ログアウトの時間設定', // 로그아웃 시간설정
  // "SET_REMOTE_UI": '', // 웹UI 원격설정
  // "ADD_STORE_MAP": '', // 점포지도 편집
  "SET_RECORDING": '録画停止', // 녹화중지 및 데이터 삭제
  // 개인 role private, branch
  // "GET_RECORDING": '', // 라이브시청 및 녹화,재생
  // "DOWNLOAD_RECORDING": '', // 녹화파일 다운로드
  // "SET_PTZ": '', // ptz 제어
  // "CALL_TWO_WAY": '', // 양방향 제어
  // "ADD_SAVED_DATA": '', // 저장된 파일
  // 하위 role main
  "GET_RECORDING_SUB_BRANCH": 'ライブ映像視聴、録画再生', // 라이브시청 및 녹화,재생
  "DOWNLOAD_RECORDING_SUB_BRANCH": '録画データダウンロード', // 녹화파일 다운로드
  "SET_PTZ_SUB_BRANCH": 'PTZ操作', // ptz 제어
  // "CALL_TWO_WAY_SUB_BRANCH": '', // 양방향 제어
  // "ADD_SAVED_DATA_SUB_BRANCH": '', // 저장된 파일
  // "SET_CONTRACT": '', // 계약 설정
  // "SET_STORE_CONFIG": '', // anonymous 표시 여부
}
*/